import { toNumber } from 'lodash'

export const isZero = (number) => { return toNumber(number) === 0 ? '' : number }